import { reduxBatch } from '@manaflair/redux-batch'
import { createAction } from '@reduxjs/toolkit'

import { doDownload } from '../../../../utils/actions'
import {
  downloadAction,
  // feedbackAction,
  printAction,
  uploadAction,
} from '../../../../utils/actions'

import { APP_CONFIG } from '../../common/constants'

import { deepCopy, numberFormatted, toCapitalize } from '../../../../utils/fns'
import { GAService } from '../../../../utils/services'
import { resultActions } from '../slices'

const handleAppEvents = (store) => (next) => (action) => {
  next(action)

  const { dispatch, getState } = store

  const {
    calculation: { input, output },
    ui,
  } = getState()

  const appEventName = GAService.getAppEventName(APP_CONFIG.appCode, ui.ecMode)
  const outputResult = Object.assign({}, output.result)
  const gaInputData = deepCopy(input)

  // Remove unused data for GA
  delete gaInputData.settings.isUSA
  delete gaInputData.jobSettings.wallMemberType
  delete gaInputData.wall.type
  delete gaInputData.roof.type

  switch (action.type) {
    case uploadAction.type: {
      const calculationData = action.payload.calculation
      const uploadedData = Object.assign({}, calculationData.input, calculationData.output)
      const gaUploadInput = deepCopy(uploadedData)

      reduxBatch(
        Object.keys(uploadedData).map((key) => {
          const action = createAction(`${key}/updateCalculation`)
          dispatch(action(uploadedData[key]))
        }),
      )

      delete gaUploadInput.settings.isUSA
      delete gaUploadInput.jobSettings.wallMemberType
      delete gaUploadInput.wall.type
      delete gaUploadInput.roof.type

      GAService.handleGAEvent({
        appEventName,
        gaActionName: GAService.APP_ACTION.UPLOAD,
        gaLabelName: 'Upload',
        gaInputData: gaUploadInput,
        gaOutputData: outputResult,
      })
      GAService.handleDataLayerEvent({
        appName: appEventName,
        appAction: GAService.APP_ACTION.UPLOAD,
        appInputs: gaUploadInput,
        appOutputData: outputResult,
      })
      break
    }
    case downloadAction.type: {
      const copiedInput = deepCopy(input)
      delete copiedInput.jobSettings.wallMemberType

      const downloadContent = {
        appCode: APP_CONFIG.appCode,
        appVersion: APP_CONFIG.appVersion,
        calculation: {
          input: numberFormatted(copiedInput),
          output: {
            result: {
              optimized: outputResult.optimized,
              searchKeyword: outputResult.searchKeyword,
            },
          },
        },
      }

      doDownload(
        downloadContent,
        `${APP_CONFIG.appCode}-${copiedInput.wall.applicationType}-${toCapitalize(
          copiedInput.roof.memberType,
        )}`,
      )

      GAService.handleGAEvent({
        appEventName,
        gaActionName: 'Download_Action',
        gaLabelName: 'Download',
        gaInputData,
        gaOutputData: outputResult,
      })

      GAService.handleDataLayerEvent({
        appName: appEventName,
        appAction: GAService.APP_ACTION.DOWNLOAD,
        appInputs: gaInputData,
        appOutputData: outputResult,
      })
      break
    }
    case printAction.type: {
      GAService.handleGAEvent({
        appEventName,
        gaActionName: 'Print_Action',
        gaLabelName: 'Print',
        gaInputData,
        gaOutputData: outputResult,
      })
      GAService.handleDataLayerEvent({
        appName: appEventName,
        appAction: GAService.APP_ACTION.PRINT,
        appInputs: gaInputData,
        appOutputData: outputResult,
      })
      break
    }
    case resultActions.getHurricaneTiesData.fulfilled.type:
    case resultActions.getHurricaneTiesData.rejected.type: {
      GAService.handleGAEvent({
        appEventName,
        gaActionName: 'Calculation_Action',
        gaLabelName: 'Calculation',
        gaInputData,
        gaOutputData: outputResult,
      })
      GAService.handleDataLayerEvent({
        appName: appEventName,
        appAction: GAService.APP_ACTION.CALCULATION,
        appInputs: gaInputData,
        appOutputData: outputResult,
      })
      break
    }
    // case feedbackAction.type: {
    //   GAService.doGAEvent(appEventName, 'Feedback_Action', action.payload)
    //   break
    // }
    case resultActions.setSelectedModel.type: {
      if (action.payload) {
        // eslint-disable-next-line no-unused-vars
        const { imageInstallation1Url, id, ...rest } = action.payload
        const label = GAService.formatGAEventLabel(rest, 'ShowIn3D')
        const dataLayerInputs = GAService.formatDataLayerInput(rest)

        GAService.doGAEvent(appEventName, 'ShowIn3D_Action', label)
        GAService.doDataLayerEvent({
          app_name: appEventName,
          app_action: 'ShowIn3D_Action',
          inputs: dataLayerInputs,
        })
      }
      break
    }
    default:
      break
  }
}

export default handleAppEvents
